import LoadingIcons from "react-loading-icons";

const LoadingComponent = ({ loadingMessage }) => {
	console.log(loadingMessage);
	return (
		<div
			style={{
				position: "fixed",
				width: "100%",
				height: "100%",
				zIndex: "10000000",
				top: "0px",
				left: "0px",
				background: "rgba(38, 43, 64, 0.80)",
			}}
		>
			<div
				style={{
					position: "fixed",
					top: "45%",
					left: "45%",
				}}
			>
				<LoadingIcons.ThreeDots />
				<br />
				<br />
				{loadingMessage && (
					<h5 style={{ color: "white", textAlign: "center" }}>{loadingMessage}</h5>
				)}
			</div>
		</div>
	);
};

export default LoadingComponent;
